import { Component } from '@angular/core';
import { ANGULAR_MODULES } from '../Shared/shared-imports';

@Component({
  selector: 'app-license-terms',
  imports: [ANGULAR_MODULES],
  standalone: true,
  templateUrl: './license-terms.html',
  styleUrl: './license-terms.scss'
})
export class LicenseTerms {

}
